const sportsInitialState = {
  sports: []
};

export default sportsInitialState;
